'use strict';

import 'slick-carousel';
import config from '../../../config/config';

export const createAccountSlider = ($container, settings) => {
    const sliderSettings = {
        lazyLoad: 'ondemand',
        infinite: false,
        autoplay: true,
        rtl: document.documentElement.lang === 'ar' ? true : false,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        dotsClass: 'slick-dots-custom',
        mobileFirst: true,
        prevArrow: config.SLICK.PREV_ARROW,
        nextArrow: config.SLICK.NEXT_ARROW,
        responsive: [
            {
                breakpoint: config.BREAKPOINTS.TABLET_MAX,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: config.BREAKPOINTS.DESKTOP_MAX,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ],
        // overwrite default settings or add new ones
        ...settings
    };

    $container.slick(sliderSettings);
};
